import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '../views/layout/Layout'

export const constantRouterMap = [
  {
    path: '/sys/department/index',
    component: Layout,
    children: [
      {
        path: '/sys/department/index',
        component: () => import(/* webpackChunkName: "p-department", webpackPrefetch: true */ '@/views/sys/department/index'),
        meta: {title: '部门管理'}
      }
    ]
  },


  {
    path: '/sys/user/index',
    component: Layout,
    name:"user",
    children: [
      {
        path: '/sys/user/index',
        component: () => import(/* webpackChunkName: "p-user", webpackPrefetch: true */ '@/views/sys/user/index'),
        meta: {title: '人员管理'}
      }
    ]
  },
  {
    path: '/sys/userReview/index',
    component: Layout,
    name: 'userReview',
    children: [
      {
        path: '/sys/userReview/index',
        component: () => import(/* webpackChunkName: "p-userReview", webpackPrefetch: true */ '@/views/sys/userReview/index'),
        meta: { title: '注册审核' }
      }
    ]
  },
      {
    path: '/HospitalManagemen',
    component: Layout,
    name: 'HospitalManagement',
    children: [
      {
        path: '/HospitalManagement',
        component: () => import(/* webpackChunkName: "p-hospital", webpackPrefetch: true */ '@/views/BaseData/HospitalManagement'),
        meta: {title: '医院管理'}
      }
    ]
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "p-login" */ '@/views/login/index'),
    hidden: true
  },
  {
    path: '/signature',
    component: () => import(/* webpackChunkName: "p-signature" */ '@/views/approval/signature/index'),
    hidden: true,
    meta: { title: '电子签名' }
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "p-404" */ '@/views/404'),
    hidden: true
  },
  {
    path: '/SystemManagement',
    component: Layout,
    redirect: '/SystemManagement',
    children: [
      {
        path: 'MenuManagement',
        name: 'MenuManagement',
        component: () => import(/* webpackChunkName: "p-menuMgmt", webpackPrefetch: true */ '@/views/SystemManagement/MenuManagement'),
        meta: {title: '菜单管理',},
      },
      {
        path: 'Role',
        name: 'Role',
        component: () => import(/* webpackChunkName: "p-role", webpackPrefetch: true */ '@/views/SystemManagement/Role'),
        meta: {title: '角色管理'}
      }
    ]
  },
  {
    path: '/DataDictionary',
    component: Layout,
    redirect: '/DataDictionary',
    children: [
      {
        path: 'DictionaryManagement',
        name: 'DictionaryManagement',
        component: () => import(/* webpackChunkName: "p-dict", webpackPrefetch: true */ '@/views/DataDictionary/DictionaryManagement'),
        meta: {title: '字典管理'}
      }
    ]
  },
  {
    path: '/approval',
    component: Layout,
    redirect: '/approval',
    name: 'approval',
    children: [
      {
        path: 'approvalClassify',
        name: 'approvalClassify',
        component: () => import(/* webpackChunkName: "p-approvalClassify", webpackPrefetch: true */ '@/views/approval/approvalClassify/index'),
        meta: { title: '审核分类管理' }
      },
      {
        path: 'approvalTemplate',
        name: 'approvalTemplate',
        component: () => import(/* webpackChunkName: "p-approvalTemplate", webpackPrefetch: true */ '@/views/approval/approvalTemplate/index'),
        meta: { title: '审核模块管理' }
      },
      {
        path: 'approvalList',
        name: 'approvalList',
        component: () => import(/* webpackChunkName: "p-approvalList", webpackPrefetch: true */ '@/views/approval/approvalList/index'),
        meta: { title: '审批列表' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },

]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js